/**
 * THE FOUR FACES, drawn as the artboards draw them (`Main.dc.html`, `Feedback.dc.html`): two eyes
 * and a mouth, 36px, in the colour of wherever they sit. Each sits beside its name, so the drawing
 * is hidden from assistive technology rather than read twice.
 */
import type { Face } from '../words.ts';

const MOUTHS: Readonly<Record<Face, string>> = {
  unhappy: 'M11.5 25.5c1.8-3 4-4.4 6.5-4.4s4.7 1.4 6.5 4.4',
  so_so: 'M12 23.5h12',
  happy: 'M11.5 21.5c1.8 3 4 4.4 6.5 4.4s4.7-1.4 6.5-4.4',
  delighted: 'M10.5 20.5h15c0 4.4-3.3 7.5-7.5 7.5s-7.5-3.1-7.5-7.5z',
};

export function FaceIcon({ face }: { face: Face }) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12.5" cy="14" r="1.75" fill="currentColor" stroke="none" />
      <circle cx="23.5" cy="14" r="1.75" fill="currentColor" stroke="none" />
      <path d={MOUTHS[face]} />
    </svg>
  );
}
